import { normalizePersonId } from '../../utils/psmAuditPermissions';

export const normalizePersonName = person => (person && typeof person === 'object' ? person.name || '' : person || '');

export const mergeFollowUpSavePayload = (followUp, requestData = {}) => {
  if (!followUp) return null;

  return {
    ...followUp,
    auditId: followUp.auditId ?? requestData.auditId,
    status: followUp.status ?? requestData.status,
    followUpById: followUp.followUpById ?? requestData.followUpById,
    name: followUp.name ?? requestData.name,
  };
};

export const normalizeFollowUpListItem = followUp => {
  if (!followUp || followUp.id == null) return null;

  const auditDate = followUp.auditDate || followUp.AuditDate || followUp.date || followUp.Date || '';
  const createdAt =
    followUp.createdAt ||
    followUp.CreatedAt ||
    followUp.createDate ||
    followUp.CreateDate ||
    followUp.followUpDate ||
    followUp.FollowUpDate ||
    '';
  const updatedAt = followUp.updatedAt || followUp.completedAt || createdAt;

  return {
    ...followUp,
    auditType: 'AuditFollowUp',
    auditor: normalizePersonName(followUp.completedBy),
    auditorId: normalizePersonId(followUp.completedBy),
    auditDate,
    createdAt,
    updatedAt,
  };
};

export const normalizeAuditListItem = item => {
  const auditDate = item.date || item.Date || '';
  const createdAt =
    item.createdAt || item.CreatedAt || item.createDate || item.CreateDate || item.createdOn || item.CreatedOn || '';
  const updatedAt = item.updatedAt || createdAt;

  return {
    ...item,
    auditor: normalizePersonName(item.auditor),
    auditorId: normalizePersonId(item.auditor) ?? normalizePersonId(item.auditorId),
    auditDate,
    createdAt,
    updatedAt,
    followUp: normalizeFollowUpListItem(item.followUp),
  };
};

export const getNotificationErrorMessage = (error, fallbackMessage) => {
  const errorData = error?.body || error?.response?.data;
  const fieldErrors = errorData?.errors;

  if (fieldErrors && typeof fieldErrors === 'object' && !Array.isArray(fieldErrors)) {
    const messages = Object.entries(fieldErrors)
      .flatMap(([field, errors]) => {
        if (Array.isArray(errors)) {
          return errors.filter(Boolean).map(message => `${field}: ${message}`);
        }
        return errors ? [`${field}: ${errors}`] : [];
      })
      .filter(Boolean);

    if (messages.length) {
      return messages.join('\n');
    }
  }

  return (
    errorData?.title ||
    errorData?.message ||
    errorData?.error ||
    (Array.isArray(fieldErrors) && fieldErrors.filter(Boolean).join(', ')) ||
    error?.message ||
    fallbackMessage
  );
};
